export default __webpack_public_path__ + "static/media/cafe_vence.b14e4855.png";